
    import { defineComponent, onBeforeMount } from 'vue'

    import SimplePage from '@/app/components/SimplePage.vue'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'

    import { useI18n } from 'vue-i18n-composable'

    export default defineComponent({
        components: {
            SimplePage
        },
        setup () {
            const i18n = useI18n()

            onBeforeMount((): void => {
                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.about.about').toString(), to: { name: 'about' } },
                    { text: i18n.t('nav.about.how-to-listen').toString() }
                ])
            })

            return {}
        }
    })
